module.exports = __webpack_public_path__ + "fonts/6fdf8d9.ttf";